import React, { Component } from "react";
import {
  RaisedButton,
  TextField,
  RefreshIndicator,
  Paper,
  Divider,
  SelectField,
  MenuItem,
  Snackbar,
  Subheader,
  FlatButton,
} from "material-ui";
import Formsy from "formsy-react";
import FormsyText from "../forms/formComponents/FormsyText";
import { FormsySelect } from "formsy-material-ui/lib";

// WYSIWYG Editor
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Editor } from "react-draft-wysiwyg";
import {
  convertToRaw,
  convertFromRaw,
  convertFromHTML,
  EditorState,
  ContentState,
} from "draft-js";
import { convertToHTML } from "draft-convert";

const toHtmlPugins = {
  styleToHTML: (style) => {
    // console.log(style)
    if (style.startsWith("fontsize")) {
      return <span style={{ fontSize: `'${style.split("-")[1]}pt'` }} />;
    }
  },
  entityToHTML: (entity, originalText) => {
    // console.log(entity.type)
    if (entity.type === "LINK") {
      return <a href={entity.data.url}>{originalText}</a>;
    }
    return originalText;
  },
};

export default class TemplateEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editorState: EditorState.createEmpty(),
      name: "",
      subject: "",
      type: "",
      typeSelection: "",
      templateTypes: [
        { name: "Email Body", id: "emailBody" },
        { name: "Attachment Template", id: "attachmentTemplate" },
      ],
      styles: {
        centerStyle: {
          marginBottom: "1em",
          marginLeft: "auto",
          marginRight: "auto",
          width: "50%",
        },
        listStyle: {
          marginTop: "0em",
          paddingTop: "0em",
          paddingLeft: "1em",
          paddingRight: "1em",
        },
        listPaperStyle: {
          marginBottom: "1em",
        },
        listItemStyle: {
          paddingLeft: "0em",
        },
      },
    };

    this.submitForm = this.submitForm.bind(this);
    this.saveTemplate = this.saveTemplate.bind(this);
    this.submitAndGetPdf = this.submitAndGetPdf.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handleTypeChange = this.handleTypeChange.bind(this);
  }

  notifyFormError(data) {
    console.error("Form error:", data);
    alert("Could not save form. Did you forget to fill out a required field?");
  }

  componentWillMount() {
    if (this.props.params._id) {
      this.props.authFetchDetails(
        `templates/getTemplate/${this.props.params._id}`,
        this.props.token.jwt,
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.details.content && nextProps.details.name) {
      let name = nextProps.details.name;
      let subject = nextProps.details.subject;
      let type = nextProps.details.type;

      let contentState;
      if (nextProps.details.contentState)
        contentState = convertFromRaw(nextProps.details.contentState);
      else if (nextProps.details.content)
        contentState = ContentState.createFromBlockArray(
          convertFromHTML(nextProps.details.content),
        );

      let editorState = contentState
        ? EditorState.createWithContent(contentState)
        : this.state.editorState;

      this.setState({
        name: name,
        subject: subject,
        type: type,
        typeSelection: type,
        editorState: editorState,
      });
    }
  }

  onChange(editorState) {
    this.setState({ editorState });
  }

  submitForm(data) {
    this.saveTemplate(data).then((id) => {
      if (!this.props.params._id)
        this.props.performRoute(
          `/job/communicationsManager/documentTemplates/${id}`,
        );
      else
        this.props.authFetchDetails(
          `templates/getTemplate/${id}`,
          this.props.token.jwt,
        );
    });
  }

  saveTemplate(data) {
    return new Promise((resolve, reject) => {
      let { editorState } = this.state;
      let content = convertToHTML(toHtmlPugins)(
        editorState.getCurrentContent(),
      );
      let contentState = convertToRaw(editorState.getCurrentContent());
      let url;
      let method;
      let body = {
        name: data.name,
        content: content,
        contentState: contentState,
        subject: data.subject,
        type: data.type,
      };

      if (this.props.params._id) {
        body.templateId = this.props.params._id;
        url = "/api/templates/edit";
        method = "PUT";
      } else {
        url = "/api/templates/new";
        method = "POST";
      }

      let options = {
        method: method,
        headers: {
          token: this.props.token.jwt,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      };
      fetch(url, options)
        .then((res) => {
          if (res.status >= 200 && res.status < 300) return res.json();
        })
        .then((id) => {
          resolve(id);
        });
    });
  }

  submitAndGetPdf() {
    let data = this.refs.form.getModel();
    this.saveTemplate(data).then((id) => {
      this.requestPdf(id);
      if (!this.props.params._id)
        this.props.performRoute(
          `/job/communicationsManager/documentTemplates/${id}`,
        );
      else
        this.props.authFetchDetails(
          `templates/getTemplate/${id}`,
          this.props.token.jwt,
        );
    });
  }

  requestPdf(template) {
    window.open(`/api/unAuth/downloadPdf?template=${template}`);
  }

  renderSelection(selection, i) {
    return (
      <MenuItem
        key={selection.id}
        primaryText={selection.name}
        value={selection.id}
      />
    );
  }

  handleTypeChange(e, val) {
    this.setState({ typeSelection: val });
  }

  render() {
    let { centerStyle } = this.state.styles;
    let { editorState } = this.state;

    return (
      <Paper
        className="container"
        zDepth={2}
        style={{ marginTop: "2em", paddingTop: "1em", paddingBottom: "1em" }}
      >
        <div style={centerStyle}>
          <h1 style={{ marginBottom: "1em" }}>Template Form</h1>
        </div>
        <Divider />
        <Subheader>Template Details</Subheader>
        <Formsy.Form
          ref="form"
          onValidSubmit={this.submitForm.bind(this)}
          onInvalidSubmit={this.notifyFormError}
        >
          <div style={centerStyle}>
            <FormsyText
              name="name"
              required
              fullWidth={true}
              // hintText='Please avoid duplicate names'
              floatingLabelText="Template Name"
              value={this.state.name}
            />
            <FormsySelect
              required
              name="type"
              floatingLabelText="Template Type"
              value={this.state.type}
              onChange={this.handleTypeChange}
            >
              {this.state.templateTypes.map(this.renderSelection)}
            </FormsySelect>
            {this.state.typeSelection === "emailBody" && (
              <FormsyText
                name="subject"
                required
                fullWidth={true}
                // hintText='Email Subject'
                floatingLabelText="Email Subject"
                value={this.state.subject}
              />
            )}
            <br />
            <br />
            <div>
              <p>Template Body</p>
              <Editor
                editorClassName="rdw-editor-main"
                editorState={editorState}
                onEditorStateChange={this.onChange}
              />
            </div>
          </div>
          <Divider />
          <br />
          <div style={centerStyle}>
            <FlatButton
              type="submit"
              label="Save Template"
              hoverColor="#BDBDBD"
            />
            <FlatButton label="Get Pdf" onClick={this.submitAndGetPdf} />
          </div>
        </Formsy.Form>
      </Paper>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/document_templates/TemplateEditor.js